/* jshint esversion: 6 */
import React from 'react';
import * as _ from "underscore";
import { Link } from 'react-router-dom';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import AccessoryModal from 'app/components/PostingTool/AccessoryModal.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';

class WelcomeBack extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            unpause: true
        };

        this.unpauseAccount = this.unpauseAccount.bind(this);

    }

    componentDidMount() {
        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Back Modal - View',
                event_data: {
                    version: this.state.version
                }
            });
        }
    }

    unpauseAccount() {
        
        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Welcome Back Modal - Unpaused'
            });
        }
        
        let user = Object.assign({}, this.props.user),
            constants = this.props.app.config.constants;

        if (this.state.unpause) {
            user.pauseButton = constants.PUB_PAUSE_OFF;
            this.props.updateUser(user);
        } else {
            user.pauseButton = constants.PUB_PAUSE_OFF;
            user.specialUnpause = 1;
            this.props.updateUser(user);
        }

    }

    render() {
        let welcomeContent = null,
            imgPath = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            buttonLabel = (this.state.unpause) ? 'Continue' : 'Continue',
            descLabel = (this.state.unpause) ? 'Turn on automations and posting' : 'Keep automations and posting paused';
    

        welcomeContent = (
            <div className="welcome-committee">
                <div className="title">Welcome Back <span>{String.fromCodePoint(0x1F44B)}</span></div>
                <div className="proposition">Enjoy a free 14 day trial on us!</div>
                <div className="options">
                    <div className="welcome-option welcome-back">
                        <div className="option-title">Pick up where you left off?</div>
                        <div className="option-graphic">
                            <ToggleControl
                                active={this.state.unpause}
                                noLabel={true}
                                callback={(e) => {
                                    let nextState = (e.currentTarget.dataset.togglestate === 'true') ? false : true;
                                    this.setState({
                                        unpause: nextState
                                    });
                                }}/>
                        </div>
                        <div className="option-desc">
                            {descLabel}
                        </div>
                    </div>
                        
                </div>
                <div className="action-button">
                    <button onClick={this.unpauseAccount}>
                        {buttonLabel}
                    </button>
                </div>
            </div>
        );

        return (
            <AccessoryModal 
                cancelAction={() => {
                    this.setState({
                        unpause: false
                    }, () => {
                        this.unpauseAccount();
                    })
                }}
                ignoreBack={true}
                mode="welcome"
                content={welcomeContent}/>
        );
        
    }
}

WelcomeBack.displayName = "WelcomeBack";

export default ComponentWithContext(WelcomeBack);